import * as React from 'react'
import * as XLSX from 'xlsx'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import mixDataConfig from '../setup/SingleDataConfig';
import Navbar from '../setup/Navbar';
import { Container, Grid2, Box, Button, Paper, Typography, Stack, Chip, Divider } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import TextField from '../../BuiltInComponent/TextField'
import StickTable from '../../BuiltInComponent/TableWithPagination'
import { addNewSingleFieldData, getAllSingleFieldData } from '../../features/AdminManagement/singleFieldSlice'
import { useDispatch, useSelector } from 'react-redux';

const normalizeSingleFieldValue = (value) => String(value || '').trim().toLowerCase();

export default function SingleDataScreen() {

    const dispatch = useDispatch()
    const location = useLocation();
    const routePath = location.pathname.replace("/", "").replace("/", "");
    const config = mixDataConfig[routePath];

    const { singleFieldData } = useSelector(state => state.sf)
    const departmentExcelInputRef = React.useRef(null)
    const [importingDepartments, setImportingDepartments] = React.useState(false)
    const [singleField, setSingleField] = React.useState(
        {
            sfID: null,
            sfScreen: config.sfScreen,
            sfHead: config.sfHead,
            sfDescription: '',
            sfStatus: true
        })
    React.useEffect(() => {
        setSingleField(prevData => ({
            ...prevData,
            sfScreen: config.sfScreen,
            sfHead: config.sfHead,

        }))
    }, [config])

    React.useEffect(() => {
        dispatch(getAllSingleFieldData({
            sfScreen: config.sfScreen,
            sfHead: config.sfHead
        }))
    }, [dispatch, config.sfScreen, config.sfHead])

    const onChange = (data) => {
        const keys = Object.keys(data)
        setSingleField(prevData => ({
            ...prevData, sfDescription: data[keys]
        }))
    }

    const onClick = async () => {
        const description = String(singleField.sfDescription || '').trim();
        if (!description) {
            return;
        }

        const duplicateExists = (singleFieldData || []).some((row) => {
            return normalizeSingleFieldValue(row.sfDescription) === normalizeSingleFieldValue(description)
                && String(row.sfScreen || '') === String(config.sfScreen || '')
                && String(row.sfHead || '') === String(config.sfHead || '');
        });

        if (duplicateExists) {
            alert(`${config.fieldLabel} already exists.`);
            return;
        }

        const payload = {
            ...singleField,
            sfDescription: description,
        };

        const resultAction = await dispatch(addNewSingleFieldData(payload));
        if (!resultAction.error) {
            setSingleField(prevData => ({
                ...prevData, sfDescription: ''
            }))

            dispatch(getAllSingleFieldData({
                sfScreen: config.sfScreen,
                sfHead: config.sfHead
            }))
        }
    }

    const downloadDepartmentsTemplate = () => {
        const worksheet = XLSX.utils.json_to_sheet([{ Department: 'Kitchen' }])
        worksheet['!cols'] = [{ wch: 35 }]
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Departments')
        XLSX.writeFile(workbook, 'departments_import_template.xlsx')
    }

    const handleDepartmentsImport = async (event) => {
        const file = event.target.files && event.target.files[0]
        if (!file) return
        setImportingDepartments(true)
        try {
            const workbook = XLSX.read(await file.arrayBuffer(), { type: 'array' })
            const worksheet = workbook.Sheets[workbook.SheetNames[0]]
            const departments = XLSX.utils.sheet_to_json(worksheet, { defval: '' })
            if (!departments.length) throw new Error('Excel file mein koi department record nahi hai')
            const response = await axios.post(
                global.SET_API_URL + 'singleFieldData/importDepartments',
                { departments }
            )
            await dispatch(getAllSingleFieldData({ sfScreen: 'Departments', sfHead: 'Departments' }))
            window.alert(response.data.message)
        } catch (error) {
            window.alert(error.response?.data?.message || error.message || String(error))
        } finally {
            setImportingDepartments(false)
            event.target.value = ''
        }
    }
    const onEditClick = async (id) => {
        console.log(id)
    }

    const onDeleteClick = async (id) => {
        console.log(id)

    }

    const tableColumns = [
        { fieldName: 'sfID', cName: 'trNo', dType: 'string', width: 10, textAlign: 'left', status: 'en' },
        { fieldName: 'sfDescription', cName: config.fieldLabel, dType: 'string', width: 1000, textAlign: 'left', status: 'en' },
        { fieldName: 'editButton', cName: 'Edit', dType: 'decimal', width: 10, textAlign: 'center', status: 'en' },
        { fieldName: 'deleteButton', cName: 'Delete ', dType: 'decimal', width: 10, textAlign: 'left', status: 'en' },
        { fieldName: 'button', cName: 'button ', dType: 'decimal', width: 10, textAlign: 'center', status: 'dis' },
    ]

    return (
        <>
            <Navbar />
            <Box sx={{
                minHeight: 'calc(100vh - 64px)',
                background: 'var(--web-theme-page-bg, #F6F7FB)',
                py: { xs: 2, md: 4 }
            }}>
                <Container maxWidth="xl">
                    <Paper elevation={0} sx={{
                        mb: 3, p: { xs: 2.5, md: 3.5 }, borderRadius: 'var(--web-theme-radius, 12px)',
                        color: 'var(--web-theme-topbar-text, #FFFFFF)', overflow: 'hidden', position: 'relative',
                        background: 'linear-gradient(135deg, var(--web-theme-topbar, #780202) 0%, var(--web-theme-primary, #780202) 58%, var(--web-theme-button, #780202) 100%)'
                    }}>
                        <Box sx={{ position: 'absolute', width: 220, height: 220, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.08)', right: -60, top: -110 }} />
                        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between" spacing={2} sx={{ position: 'relative' }}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Box sx={{ width: 54, height: 54, borderRadius: 2.5, display: 'grid', placeItems: 'center', bgcolor: 'rgba(255,255,255,0.14)', border: '1px solid rgba(255,255,255,0.22)' }}>
                                    <ApartmentRoundedIcon sx={{ fontSize: 31 }} />
                                </Box>
                                <Box>
                                    <Typography variant="h4" sx={{ fontWeight: 800, letterSpacing: -0.5 }}>{config.heading}</Typography>
                                    <Typography sx={{ opacity: 0.82, mt: 0.3 }}>Create and manage {config.heading.toLowerCase()} from one place</Typography>
                                </Box>
                            </Stack>
                            <Chip label={`${(singleFieldData || []).length} records`} sx={{ bgcolor: 'rgba(255,255,255,0.16)', color: 'var(--web-theme-topbar-text, #FFFFFF)', fontWeight: 700, border: '1px solid rgba(255,255,255,0.22)' }} />
                        </Stack>
                    </Paper>

                    {routePath === 'Departments' && (
                        <Paper variant="outlined" sx={{ mb: 3, p: 2, borderRadius: 'var(--web-theme-radius, 12px)', borderColor: 'var(--web-theme-primary, #780202)', bgcolor: 'var(--web-theme-card-bg, #FFFFFF)' }}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" spacing={2}>
                                <Box>
                                    <Typography fontWeight={750}>Bulk Excel tools</Typography>
                                    <Typography variant="body2" color="text.secondary">Download the sample format, fill departments, then import the file.</Typography>
                                </Box>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25}>
                                    <Button startIcon={<DownloadRoundedIcon />} variant="outlined" onClick={downloadDepartmentsTemplate}>Download Template</Button>
                                    <Button startIcon={<UploadFileRoundedIcon />} variant="contained" disabled={importingDepartments} onClick={() => departmentExcelInputRef.current.click()}>
                                        {importingDepartments ? 'Importing...' : 'Import Excel'}
                                    </Button>
                                    <input ref={departmentExcelInputRef} type="file" accept=".xlsx,.xls" hidden onChange={handleDepartmentsImport} />
                                </Stack>
                            </Stack>
                        </Paper>
                    )}

                    <Grid2 container spacing={3} alignItems="flex-start">
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            <Paper elevation={0} variant="outlined" sx={{ p: { xs: 2.25, md: 3 }, borderRadius: 'var(--web-theme-radius, 12px)', borderColor: 'rgba(0,0,0,0.1)', bgcolor: 'var(--web-theme-card-bg, #FFFFFF)', position: { md: 'sticky' }, top: { md: 16 } }}>
                                <Typography variant="h6" fontWeight={800}>Add {config.fieldLabel}</Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2.5 }}>Enter a unique description to create a new record.</Typography>
                                <TextField id={singleField} name={singleField} label={config.fieldLabel} onChange={onChange} value={singleField.sfDescription} />
                                <Button fullWidth size="large" variant="contained" startIcon={<AddRoundedIcon />} onClick={onClick} sx={{ mt: 2, py: 1.15, borderRadius: 2, fontWeight: 750 }}>
                                    Add {routePath === 'Departments' ? 'Department' : 'Record'}
                                </Button>
                            </Paper>
                        </Grid2>

                        <Grid2 size={{ xs: 12, md: 8 }}>
                            <Paper elevation={0} variant="outlined" sx={{ borderRadius: 'var(--web-theme-radius, 12px)', borderColor: 'rgba(0,0,0,0.1)', overflow: 'hidden', bgcolor: 'var(--web-theme-card-bg, #FFFFFF)' }}>
                                <Box sx={{ px: { xs: 2, md: 3 }, py: 2.25 }}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                        <Box>
                                            <Typography variant="h6" fontWeight={800}>{config.heading} List</Typography>
                                            <Typography variant="body2" color="text.secondary">All active records currently available in the system.</Typography>
                                        </Box>
                                        <Chip size="small" color="primary" variant="outlined" label={(singleFieldData || []).length} />
                                    </Stack>
                                </Box>
                                <Divider />
                                <Box sx={{ p: { xs: 1, md: 2 } }}>
                                    <StickTable
                                        modernStyle
                                        tableData={singleFieldData || []}
                                        tableColumns={tableColumns}
                                        perPage={10}
                                        onEditClick={onEditClick}
                                        onDeleteClick={onDeleteClick}
                                    />
                                </Box>
                            </Paper>
                        </Grid2>
                    </Grid2>
                </Container>
            </Box>
        </>
    )
}